import { ReactElement } from 'react';
import { useDialog } from '~/hooks';
import { DialogSection } from '../dialog-section.component';
import { StyledModal as Dialog } from '../dialog.style';

interface Props {
  target: ReactElement;
}

export const AcbBillingExplainerDialog = ({ target }: Props) => {
  const { isOpen, close, TargetComponent } = useDialog(target);

  return (
    <>
      {TargetComponent}
      <Dialog isOpen={isOpen} onDismiss={close} aria-label="ACB Billing Explainer">
        <Dialog.Header title="Why pay through our platform?" onClose={close} />
        <DialogSection title="The only one-bill solution available:">
          {[
            'Pay for your power bill, your solar credits and see your solar savings in one simple, streamlined statement.',
          ]}
        </DialogSection>
        <DialogSection title="Auto-pay for peace of mind:">
          {[
            'You’ll automatically pay your power bill through our platform every month. Your utility company knows that payments will be coming through Arcadia, so you don’t have to go on their website directly anymore.',
          ]}
        </DialogSection>
        <Dialog.FooterStacked primaryText="Close" onSubmit={close} />
      </Dialog>
    </>
  );
};
